/**
 * 查看详情
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/4/18      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import Lang from "@components/Lang/Lang";
import {Modal,Table} from 'antd';
import {toFixedWithCommas} from "@/utils/number-util";
import {postOrderStatisticsDetail} from "@/api/financeManagement";
import "./index.less";

class Detail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            model:{},
            models:[],
            loading: false,
            pagingQuery: {
                pageSize: 50,
                total: 0,
                pageNum: 1
            },
        }
    }

    /**
     * 显示or隐藏
     * @param visible
     */
    changeVisible(visible){
        this.setState({
            visible:visible
        },()=> {
            if (visible) {
                this.getData();
            }
        })
    }

    /**
     * 获取数据源
     */
    getData(pageIndex){
        postOrderStatisticsDetail({
            buyerId:this.props.buyerId,
            beginTime:this.props.beginTime,
            endTime:this.props.endTime,
            saleCountryTransactionServiceId:this.props.saleCountryTransactionServiceId,
            pagingQuery: {
                pageIndex: pageIndex||this.state.pagingQuery.pageNum,
                pageSize: this.state.pagingQuery.pageSize,
            },
        }).then((res)=>{
            this.setState({
                model:res.data.model||{},
                models:res.data.models||{},
            })
        })
    }

    /**
     * 切换分页
     * @param pagination
     */
    handlePagination = (pagination) => {
        this.getData(pagination.current);
    }

    /**
     * 获取状态
     * @param status
     * @return {{}}
     */
    getStatus(status){
        var result = {}
        switch (status) {
            case '0':
                result = {
                    color: 'orange',
                    statusName:__getServerLanguage('DaiZhiFuDingJin')
                }
                break;
            case '1':
                result = {
                    color: 'blue',
                    statusName:__getServerLanguage('JinXingZhong')
                }
                break;
            case '2':
                result = {
                    color: 'orange',
                    statusName:__getServerLanguage('DaiZhiFuWeiKuan')
                }
                break;
            case '3':
                result = {
                    color: 'green',
                    statusName:__getServerLanguage('YiWanCheng')
                }
                break;
            case '4':
                result = {
                    color: 'gray',
                    statusName:__getServerLanguage('YiQuXiao')
                }
                break;
            case '5':
                result = {
                    color: 'orange',
                    statusName:__getServerLanguage('DaiZhiFuQuanKuan')
                }
                break;
            case '6':
                result = {
                    color: 'blue',
                    statusName:__getServerLanguage('DaiTiHuo')
                }
                break;
        }
        return result;
    }

    getColumns(props){
        let {model,getStatus} = props;
        return [
            {
                title: Lang({id: "KeHu", default: "订单"}),
                width:300,
                render: (text, record) => {
                    return <div className={"flex-item-between"}>
                        <a target="_blank" href={`/order/sale/detail?id=${record.poId}`}>{record.poCode}</a>
                        {
                            text.isFirstOrder?
                                <span className="status-tag status-red ml_6">{Lang({id: "ShouDan", default: "首单"})}</span>
                                :
                                null
                        }
                    </div>
                }
            },
            {
                title: <span></span>,
                render: (text, record) => {
                    let status = getStatus(record.status);
                    return <div>
                        <span className={`status-tag status-${status.color}`}>{status.statusName}</span>
                    </div>
                }
            },
            {
                title: Lang({id: "DinDanJinE", default: "订单金额"}),
                align:'right',
                render: (text, record) => {
                    return <div>
                        {record.orderAmount||'0.00'} {model.currencySymbol||'-'}
                    </div>
                }
            },
        ]
    }

    render(){
        const model = this.state.model||{};
        let dataSource = this.state.models||[];
        let columns = this.getColumns;
        return (
            <span>
                <span onClick={this.changeVisible.bind(this,true)}>
                    {this.props.children}
                </span>
                <Modal open={this.state.visible}
                       width={700}
                       okText={Lang({id: "QueDing",default: "确定"})}
                       cancelText={Lang({id: "QuXiao",default: "取消"})}
                       onOk={this.changeVisible.bind(this,false)}
                       onCancel={this.changeVisible.bind(this,false)}>
                    <div className="order-status-detail-wrap">
                        <div className="title">{model.buyerCode||'-'}</div>
                        <ul className="count-wrap">
                            <li>
                                <div>
                                    <p>{Lang({id: "YuE",default: "余额"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.balance,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p>{Lang({id: "ShengChanZhongDingDan",default: "生产中订单"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.productionOrderAmount,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p>{Lang({id: "DaiFuWeiKuanDingDan",default: "待付尾款订单"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.toBePayOrderAmount,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <p>{Lang({id: "YiTiHuoDingDan",default: "已提货订单"})}</p>
                                    <p>
                                        <b>{toFixedWithCommas(model.pickedUpOrderAmount,2)} {model.currencySymbol}</b>
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <Table className="mt_16" dataSource={dataSource}
                               columns={columns({
                                   model:model,
                                   getStatus:this.getStatus,
                               })}
                               rowKey="id"
                               scroll={{ y: 200 }}
                               onChange={this.handlePagination}
                               pagination={{
                                   defaultPageSize: this.state.pagingQuery.pageSize,
                                   total: this.state.pagingQuery.total,
                                   current: this.state.pagingQuery.pageIndex,
                                   showSizeChanger: false,
                               }}
                        />
                    </div>
                </Modal>
            </span>
        )
    }
}

Detail.defaultProps = {
    saleCountryTransactionServiceId:null,
    buyerId:null
}

Detail.propTypes = {

}
export default Detail;
